module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2aRLGC/tc-custom/9780813143828.jpg?1737164481568",
      "alt": "This image is the cover for the book Kentucky Hauntings"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kentucky Hauntings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“This wonderful collection of Kentucky ghost stories” is a treasure trove of history, heritage, and commentary on the oral tradition of storytelling (Elizabeth Tucker, author of "), _c('i', [_vm._v("Haunted Halls")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Kentucky Hauntings")]), _vm._v(", beloved storytellers Roberta Simpson Brown and Lonnie E. Brown present a thrilling collection of paranormal tales that will appeal to anyone looking for a friendly scare. Weaving together factual accounts of unexplained events, peculiar headlines, and local legends passed down from a time when most homes lacked electricity, "), _c('i', [_vm._v("Kentucky Hauntings")]), _vm._v(" combines spooky stories with commentary on historic customs."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From \"telling the bees\" about a death in the family, to a friendly \"fool's errand\" practical joke gone horribly wrong, and from terrifying haunted houses to the lifesaving \"Bathtub Ghost,\" readers are transported to a world of age-old superstitions and paranormal experiences. Whether shared around the fire on a crisp autumn night or whispered in a huddle of close friends at a summer sleepover, these eerie stories will thrill and excite anyone who loves a good scare.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roberta Simpson Brown, Lonnie E. Brown\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University Press of Kentucky\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0